<template lang="html">
  <router-view id="content"/>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>



</style>
